<template>
  <div :class="$style.results">
    {{ countText
    }}<span :class="$style['results-text']">{{ $tc('search.result_count', count) }}</span>
    <!-- {{ countText }} -->
    <v-progress-circular
      v-if="searchInitial || searchPending"
      size="20"
      width="2"
      color="primary"
      :indeterminate="searchInitial || searchPending"
    />
  </div>
</template>

<script>
import { get } from 'lodash-es'
import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'
import GETTER_TYPES from '@/js/plugins/store/modules/aimeos/getter-types'
import API_CONSTANTS from '@/js/helper/api-constants.js'

export default {
  name: 'MobileFilterCount',
  components: {},
  computed: {
    ...mapGetters(STOREMODULES.AIMEOS, {
      searchData: GETTER_TYPES.SEARCH_DATA,
      searchPending: `SEARCH_${REQUEST_STATE.STATE_PENDING}`,
      searchFailure: `SEARCH_${REQUEST_STATE.STATE_FAILURE}`,
      searchInitial: `SEARCH_${REQUEST_STATE.STATE_INITIAL}`,
    }),
    productListData() {
      return {
        meta: get(this.searchData, API_CONSTANTS.META.TYPE, {}),
      }
    },
    count() {
      return this.productListData.meta.total || 0
    },
    countText() {
      return this.searchInitial || this.searchPending ? '…' : this.count

      // return this.searchInitial || this.searchPending
      //   ? this.$tc('search.result_count', 2, { count: '…' })
      //   : this.searchFailure
      //   ? this.$tc('search.result_count', 0, { count: 0 })
      //   : this.$tc(
      //       'search.result_count',
      //       this.count,
      //       { count: this.count },
      //       console.log(this.count),
      //     )
    },
  },
}
</script>

<style lang="scss" module>
.results {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    font-size: 1.3rem;
  }
  margin-right: 1rem;

  font-size: 1rem;
}

.results-text {
  margin-right: 4px;
  margin-left: 4px;

  font-size: 0.9rem;
}
</style>
